import React, { useState } from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

interface CopyableIdProps {
	copiableIdValue: string;
	label?: string;
}

const CopyableId: React.FC<CopyableIdProps> = (props: CopyableIdProps) => {
	const [copied, setCopied] = useState<boolean>(false);
	const { copiableIdValue, label = 'ID' } = props;
	const handleCopy = () => {
		navigator.clipboard.writeText(copiableIdValue.toString());
		setCopied(true);
		setTimeout(() => {
			setCopied(false);
		}, 2000);
	};

	return (
		<Box display="flex" alignItems="center">
			<Typography variant="subtitle2">
				{label}: <span>{copiableIdValue}</span>
			</Typography>
			<Tooltip title={copied ? 'Copiado satisfactoriamente' : 'Copiar ID'}>
				<IconButton size="small" onClick={handleCopy}>
					{copied ? <CheckIcon style={{ color: 'green' }} fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
				</IconButton>
			</Tooltip>
		</Box>
	);
};

export default CopyableId;
